import React from 'react';

//React redux:
import { connect } from 'react-redux';

//Material UI:
import Grid from '@mui/material/Grid';
import { Box, Typography } from '@mui/material';

//Actions:
import { atnPortabilityAction } from '_models/redux/atn-portability/action';
import { cleanAtnPortabilityAction } from '_models/redux/atn-portability/clean-action';

//Hooks:
import { usePortabilityPageHook } from './hooks/usePortabilityPageHook';

//Components:
import DataTable from 'widgets/datagrid/DataTable';
import SectionFilterComponent from './components/SectionFilterComponent';

function PortabilityPageComponent({
  atnPortabilityAction,
  cleanAtnPortabilityAction,
  atnPortability,
}) {
  const {
    register,
    handleSubmit,
    errors,
    onSubmit,
    handleCleanFilters,
    loading,
    page,
    size,
    pagination,
    mappedRows,
    handleRowClick,
    Columns,
    errorMessage,
    hasSearched,
  } = usePortabilityPageHook({
    atnPortabilityAction,
    cleanAtnPortabilityAction,
    atnPortability,
  });
  return (
    <Box>
      <h4> Portabilidades </h4>
      <Box sx={{ mb: 10 }}>
        <SectionFilterComponent
          onSubmit={onSubmit}
          handleSubmit={handleSubmit}
          errors={errors}
          register={register}
          onCleanFilters={handleCleanFilters}
        />
        {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
      </Box>

      {hasSearched ? (
        mappedRows?.length > 0 ? (
          <Grid item size={{ xs: 12 }} sx={{ width: 'calc(100vw - 280px)' }}>
            <Box sx={{ height: '67vh' }}>
              <DataTable
                rows={mappedRows}
                columns={Columns}
                onRowClick={handleRowClick}
                page={page}
                pageSize={size}
                rowCount={pagination?.total_rows ?? 0}
                onPageChange={pagination?.handleChangePage}
                handleChangePageSize={pagination?.handleChangePageSize}
                loading={loading}
              />
            </Box>
          </Grid>
        ) : (
          <Typography variant='h6'>No hay registros disponibles</Typography>
        )
      ) : null}
    </Box>
  );
}

const mapStateToProps = (state) => ({
  atnPortability: state?.atnPortability,
});

const mapDispatchToProps = {
  atnPortabilityAction,
  cleanAtnPortabilityAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(PortabilityPageComponent);
